import uuid from "uuid/v4";

const store = {
    namespaced: true,
    state: {
      guidanceItems: [],
      employerId: null, 
      messages: [],
      loading: false,
      panelClosed: false
    },
    actions: {
      async load({state, dispatch}, employerId) {
        if (!employerId) return;
        if (state.employerId == employerId) return;
        await dispatch("reload", employerId);
      },
      async reload({commit}, employerId) {
        if (!employerId) return;
        commit("setData", { loading: true });
        var response = await romeApi.get(`employer/${employerId}/guidance`);
        commit("setGuidancePlanShortName", {guidanceItems: response});
        commit("setGuidanceItems", { employerId: employerId, guidanceItems: response });
      },
      async highlightRow({dispatch}, data) {
        await dispatch("sendExpiringMessage", { id: uuid(), type: "highlight-row", url: data.url, row: data.row });
      },
      async clearHighlight({dispatch}) {
        await dispatch("sendExpiringMessage", { id: uuid(), type: "clear-highlight"});
      },
      async refreshGuidancePanel({dispatch}) {
        await dispatch("sendExpiringMessage", { id: uuid(), type: "refresh-guidance-panel"});
      },
      async sendExpiringMessage({commit}, msg) {
        commit("addMessage", msg);
        _.delay(() => commit("removeMessage", msg.id), 1000);
      },
      async toggleGuidancePanel({commit}, data) {
        commit("togglePanel", data);
      }
    },
    mutations: {
      addMessage(state, msg) {
        state.messages.push(msg);
      },
      removeMessage(state, msgId) {
        let index = _.findIndex(state.messages, m => m.id == msgId);
        if (index >= 0) state.messages.splice(index, 1);
      },
      setData(state, data) {
        utils.copyCommonProperties(data, state);
      },
      setGuidanceItems(state, data) {
        state.employerId = data.employerId;
        state.guidanceItems = data.guidanceItems;
        state.loading = false;
      },
      setGuidancePlanShortName(state, data){
        for(let i = 0; i < data.guidanceItems.length; i++){
          var item = data.guidanceItems[i];
          if(item.parameters && item.parameters.planShortName) continue;
          if (item.parameters && item.parameters.planType){
            var planShortName = item.parameters.planType;
            data.guidanceItems[i].parameters.planShortName = planShortName;
          }
        }
      },
      togglePanel(state, data) {
        state.panelClosed = data;
      }
    }
  };
  
  export default store;


// WEBPACK FOOTER //
// ./src/guidance/x-guidance.js